// ==============================|| DEFAULT THEME - TYPOGRAPHY ||============================== //

export default function Typography(fontFamily) {
    return {
        fontFamily,
        htmlFontSize: 16,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 600,
        h1: {
            fontSize: 96,
            fontStyle: 'normal',
            fontWeight: 300,
            lineHeight: '150%',
            letterSpacing: '-1.5px',
        },
        h2: {
            fontSize: 60,
            fontStyle: 'normal',
            fontWeight: 300,
            lineHeight: '150%',
            letterSpacing: '-0.5px',
        },
        h3: {
            fontSize: 48,
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '150%',
        },
        h4: {
            fontSize: 34,
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '150%',
            letterSpacing: 0.25,
        },
        h5: {
            fontSize: 24,
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '150%',
        },
        h6: {
            fontSize: 20,
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '150%',
            letterSpacing: 0.15,
        },
        subtitle1: {
            fontSize: 16,
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '150% ',
            letterSpacing: 0.15,
        },
        subtitle2: {
            fontSize: 14,
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '150%',
            letterSpacing: 0.1,
        },
        body1: {
            fontSize: 16,
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '150%',
            letterSpacing: 0.5,
        },
        body2: {
            fontSize: 14,
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '150%',
            letterSpacing: 0.25,
        },
        caption: {
            fontSize: 12,
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '125%',
            letterSpacing: 0.4,
        },
        overline: {
            fontSize: 10,
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '120%',
            letterSpacing: 1.5,
            textTransform: 'uppercase',
        },
        button: {
            fontSize: 14,
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '114.286%',
            letterSpacing: 1.25,
            textTransform: 'uppercase',
        },
    }
}
